
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flex/[partner]",
      function () {
        return require("private-next-pages/flex/[partner].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flex/[partner]"])
      });
    }
  